/**
 * Bản dịch tiếng Việt (i18n) — export object `vi` dùng qua shared/languages.
 *
 * Cấu trúc: namespace theo màn hình/domain (common, auth, property, admin...).
 * Mỗi key là chuỗi UI; nested object cho form, validation, dialog.
 * Import TEXT từ shared/languages để dùng trong component.
 */
export const vi = {
  validation: {
    phoneRequired: 'Vui lòng nhập số điện thoại.',
    phoneInvalid:
      'Số điện thoại không hợp lệ. Vui lòng nhập số di động Việt Nam (10 số, bắt đầu bằng 0).',
    budgetRangeInvalid: 'Ngân sách tối đa phải lớn hơn hoặc bằng ngân sách tối thiểu.',
    cccdInvalid: 'CCCD phải gồm đúng 12 chữ số.',
  },
  common: {
    brandName: 'Bất Động Sản Giá Tốt',
    home: 'Trang chủ',
    back: 'Quay lại',
    close: 'Đóng',
    viewAll: 'Xem tất cả',
    viewMore: 'Xem thêm',
    viewDetails: 'Xem chi tiết',
    tryAgain: 'Thử lại',
    resetFilters: 'Xóa lọc',
    listings: 'tin đăng',
    notUpdated: 'Chưa cập nhật',
    notAvailable: 'Chưa có',
    noPhone: 'Chưa có SĐT',
    noAddress: 'Chưa có địa chỉ',
    uncategorized: 'Chưa phân loại',
    any: 'Bất kỳ',
    unlimited: 'Không giới hạn',
    selectPlaceholder: 'Chưa chọn',
    required: 'Bắt buộc',
    info: 'Thông tin',
    edit: 'Sửa',
    delete: 'Xóa',
    deleting: 'Đang xóa...',
    approve: 'Duyệt',
    approving: 'Đang duyệt...',
    save: 'Lưu tin đăng',
    saving: 'Đang lưu...',
    creating: 'Đang tạo...',
    submitting: 'Đang gửi...',
    searching: 'Đang tìm...',
    previous: 'Trước',
    next: 'Sau',
    firstPage: 'Trang đầu',
    lastPage: 'Trang cuối',
    description: 'Mô tả',
    amenities: 'Tiện ích',
    areaUnit: 'm²',
    bedroomShort: 'PN',
    bathroomShort: 'WC',
    views: 'Lượt xem',
    viewedBy: 'người đã xem',
    currencyUnit: 'VNĐ',
    billionUnit: 'tỷ',
    millionUnit: 'triệu',
    budgetFrom: 'Từ {amount}',
    budgetUpTo: 'Đến {amount}',
    searchNoResultsMessage: 'Thử đổi từ khóa tìm kiếm.',
  },
  nav: {
    searchAnywhere: 'Tìm khu vực, loại nhà...',
    searchButton: 'Tìm kiếm',
    admin: 'Quản trị thông tin',
    favorites: 'Yêu thích',
    profile: 'Hồ sơ',
    login: 'Đăng nhập',
    logout: 'Đăng xuất',
    register: 'Đăng ký',
    viewWebsite: 'Xem website',
    greeting: 'Xin chào',
    guest: 'bạn',
  },
  footer: {
    allListings: 'Tất cả tin đăng',
    hotline: 'Hotline: 0977545638',
    supportText: 'Chuyên Hỗ Trợ Mua Bán Bất Động Sản',
  },
  home: {
    sectionSale: 'Mới nhất',
    sectionRent: 'Nhà đất đang cho thuê',
    sectionPopular: 'Được tìm kiếm nhiều nhất',
    emptySectionTitle: 'Chưa có tin phù hợp',
    emptySectionMessage: 'Hãy thử chọn danh mục khác hoặc quay lại xem tất cả tin đăng.',
  },
  auth: {
    loginTitle: 'Đăng nhập',
    loginSubmitting: 'Đang đăng nhập...',
    logoutSubmitting: 'Đang đăng xuất...',
    registerTitle: 'Đăng ký',
    registerDescription: 'Lưu bất động sản yêu thích và nhận tư vấn nhanh hơn.',
    registerSubmitting: 'Đang tạo tài khoản...',
    hasAccount: 'Đã có tài khoản?',
    noAccount: 'Chưa có tài khoản?',
    registerFree: 'Đăng ký miễn phí',
    fullName: 'Họ tên',
    email: 'Email',
    phone: 'Số điện thoại',
    password: 'Mật khẩu',
    loginOrSignup: 'Đăng nhập hoặc đăng ký',
    continue: 'Tiếp tục',
    orDivider: 'hoặc',
    welcomeBack: 'Chào mừng trở lại',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Mật khẩu',
    continueWithApple: 'Tiếp tục với Apple',
    socialLoginFailed: 'Không thể đăng nhập bằng mạng xã hội. Vui lòng thử lại.',
  },
  property: {
    defaultCategory: 'Bất động sản',
    transactionType: {
      sale: 'Bán',
      rent: 'Cho thuê',
      saleListing: 'Đang bán',
      saleDetail: 'Mua bán',
      buyOrRent: 'Mua hoặc thuê',
      buy: 'Mua',
      rentShort: 'Thuê',
    },
    list: {
      breadcrumb: 'Tìm bất động sản',
      eyebrow: 'Danh sách nhà đất',
      title: 'Tìm bất động sản phù hợp',
      description: 'Lọc nhanh bằng các thông tin cơ bản. Nếu chưa chắc, cứ để trống và xem tất cả.',
      searchButton: 'Tìm nhà',
      resultSummary: 'Có {count} bất động sản phù hợp',
      resultCountLabel: '{count} bất động sản',
      mapPanelTitle: 'Bản đồ kết quả',
      mapNoCoordinates: 'Các tin trong trang này chưa có tọa độ trên bản đồ.',
      mapLoadError: 'Không thể tải bản đồ. Vui lòng thử lại sau.',
      areaMapTitle: 'Lọc theo khu vực',
      areaMapHint: 'Bấm vào khu vực trên bản đồ để lọc danh sách.',
      emptyTitle: 'Không tìm thấy bất động sản',
      emptyMessage: 'Hãy thử điều chỉnh bộ lọc hoặc từ khóa tìm kiếm.',
    },
    detail: {
      notFoundTitle: 'Không tìm thấy bất động sản',
      notFoundMessage: 'Tin đăng có thể đã hết hiệu lực hoặc bị gỡ khỏi hệ thống.',
      backToList: 'Quay lại danh sách',
      breadcrumb: 'Tìm bất động sản',
      noDescription: 'Tin đăng chưa có mô tả chi tiết.',
      saveFavorite: 'Lưu vào yêu thích',
      savingFavorite: 'Đang lưu...',
      galleryMainAlt: 'Bất động sản',
      gallerySideAlt: 'Không gian nhà đất',
      openGallery: 'Xem ảnh lớn',
      morePhotos: 'ảnh',
      lightboxPrev: 'Ảnh trước',
      lightboxNext: 'Ảnh sau',
      lightboxZoomIn: 'Phóng to',
      lightboxZoomOut: 'Thu nhỏ',
      lightboxCounter: '{current} / {total}',
      bedroom: 'phòng ngủ',
      bathroom: 'phòng tắm',
      parkingSlot: 'chỗ đậu xe',
      floor: 'tầng',
      furnished: 'Nội thất',
      legal: 'Pháp lý',
      mapTitle: 'Khu vực tư vấn',
      mapUnavailable: 'Tin đăng chưa có khu vực tư vấn.',
      mapAddressFallback: 'Liên hệ để được tư vấn vị trí phù hợp và kiểm tra lịch xem nhà.',
      openInMaps: 'Liên hệ để nhận vị trí',
      priceContactCta: 'Liên hệ để biết giá chính xác',
      specsTitle: 'Thông số chính',
      featuresTitle: 'Tiện ích & pháp lý',
      areaLabel: 'Diện tích',
      similarTitle: 'Bất động sản tương tự',
      similarEyebrow: 'Gợi ý cho bạn',
      showAllPhotos: 'Xem tất cả ảnh',
      contactCta: 'Liên hệ tư vấn',
      bookingNote: 'Gọi hoặc để lại thông tin, chúng tôi sẽ phản hồi sớm nhất.',
      loginToSave: 'để lưu tin yêu thích.',
      perMonth: '/ tháng',
      fieldTransaction: 'Nhu cầu',
      fieldCategory: 'Loại',
      hostedBy: 'Đăng bởi {name}',
      hostSubtitle: '{category} tại {location}',
      defaultHost: 'Bất Động Sản Giá Tốt',
      whereTitle: 'Khu vực',
      areaMapTitle: 'Bản đồ khu vực',
      areaMapHint: 'Bản đồ chỉ hiển thị khu vực tổng quát.',
      showMore: 'Xem thêm',
      showLess: 'Thu gọn',
      viewsLabel: '{count} lượt xem',
    },
    filters: {
      groupSearch: 'Từ khóa',
      groupLocation: 'Khu vực & nhu cầu',
      groupPropertyType: 'Loại nhà đất',
      groupPrice: 'Mức giá',
      groupAmenities: 'Tiện ích',
      groupRoomSpecs: 'Thông số phòng',
      groupPosition: 'Vị trí',
      roomSpecQuantityLabel: 'Số lượng tối thiểu',
      groupDimensions: 'Diện tích',
      groupSort: 'Sắp xếp kết quả',
      searchLabel: 'Bạn muốn tìm gì?',
      searchPlaceholder: 'Ví dụ: căn hộ 2 phòng ngủ, nhà phố...',
      transactionLabel: 'Nhu cầu',
      categoryLabel: 'Loại nhà đất',
      allCategories: 'Tất cả',
      expandSection: 'Mở rộng',
      collapseSection: 'Thu gọn',
      minPriceLabel: 'Giá tối thiểu',
      maxPriceLabel: 'Giá tối đa',
      minAreaLabel: 'Diện tích tối thiểu',
      maxAreaLabel: 'Diện tích tối đa',
      minFrontageLabel: 'Chiều ngang tối thiểu',
      minLengthLabel: 'Chiều dài tối thiểu',
      positionLabel: 'Vị trí',
      accessStreetFront: 'Mặt tiền',
      accessAlley: 'Ngõ / hẻm',
      amenityParking: 'Bãi đỗ xe',
      amenityBalcony: 'Ban công',
      amenityPool: 'Hồ bơi',
      bedroomLabel: 'Phòng ngủ',
      bathroomLabel: 'Nhà vệ sinh',
      frontagePlaceholder: 'Ví dụ: 5',
      lengthPlaceholder: 'Ví dụ: 20',
      sortLabel: 'Sắp xếp',
      toggleFilters: 'Bộ lọc',
      hideFilters: 'Thu gọn',
      savedFiltersTitle: 'Bộ lọc đã lưu',
      savedFilterName: 'Tên bộ lọc',
      saveFilterButton: 'Lưu bộ lọc hiện tại',
      applySavedFilter: 'Áp dụng',
      removeSavedFilter: 'Xóa',
      notifySavedFilter: 'Nhận thông báo khi có tin mới',
      notifyHint: 'Tính năng email sẽ được bật sau.',
    },
    form: {
      createEyebrow: 'Thêm mới',
      editEyebrow: 'Chỉnh sửa',
      createTitle: 'Thêm bất động sản',
      editTitle: 'Sửa bất động sản',
      pendingNotice:
        'Tin đăng của admin sẽ được chuyển sang trạng thái chờ duyệt. Superadmin sẽ duyệt trước khi tin được public.',
      categoryLabel: 'Loại bất động sản',
      selectCategory: 'Chọn loại',
      transactionLabel: 'Nhu cầu',
      priceLabel: 'Giá bán',
      rentPriceLabel: 'Giá cho thuê',
      priceUnit: 'VNĐ',
      rentPriceUnit: 'VNĐ/tháng',
      pricePlaceholder: 'Ví dụ: 3,500,000,000',
      pricePerSqmLabel: 'Giá/m²',
      pricePerSqmUnit: 'VNĐ/m²',
      pricePerSqmPlaceholder: 'Ví dụ: 45,000,000',
      titleLabel: 'Tiêu đề',
      locationSummaryLabel: 'Địa chỉ / khu vực',
      locationSummaryPlaceholder: 'Tự động tạo từ Tỉnh/Thành phố và Phường/Xã',
      locationHint:
        'Chọn tỉnh/thành phố và phường/xã theo cơ cấu hành chính mới (2025). Website chỉ hiển thị khu vực tổng quát; vị trí chi tiết sẽ tư vấn trực tiếp.',
      provinceLabel: 'Tỉnh / thành phố',
      selectProvince: 'Chọn tỉnh / thành phố',
      districtLabel: 'Quận / huyện',
      selectDistrict: 'Chọn quận / huyện',
      wardLabel: 'Phường / xã',
      selectWard: 'Chọn phường / xã',
      addressLabel: 'Địa chỉ cụ thể',
      addressPlaceholder: 'Số nhà, tên đường, tòa nhà...',
      areaLabel: 'Diện tích (m²)',
      areaPlaceholder: 'Ví dụ: 85',
      frontageLabel: 'Bề ngang (m)',
      frontagePlaceholder: 'Ví dụ: 5',
      plotLengthLabel: 'Chiều dài (m)',
      plotLengthPlaceholder: 'Tự tính từ diện tích / bề ngang',
      plotLengthHint: 'Chiều dài được tự động tính khi nhập diện tích và bề ngang.',
      bedroomLabel: 'Phòng ngủ',
      bathroomLabel: 'Phòng tắm',
      toiletLabel: 'Toilet',
      kitchenLabel: 'Phòng bếp',
      floorLabel: 'Số tầng',
      masterBedroomLabel: 'Phòng master',
      gymRoomLabel: 'Phòng thể dục',
      livingRoomLabel: 'Phòng khách',
      worshipRoomLabel: 'Phòng thờ',
      roomSpecQuantityLabel: 'Số lượng',
      parkingLabel: 'Chỗ đậu xe',
      furnishedLabel: 'Tình trạng nội thất',
      legalLabel: 'Pháp lý',
      legalPlaceholder: 'Sổ hồng, hợp đồng mua bán...',
      statusLabel: 'Trạng thái',
      publicationLabel: 'Trạng thái đăng',
      imagesLabel: 'Ảnh bất động sản',
      imagesHint: 'Chỉ chấp nhận ảnh JPG, JPEG hoặc PNG.',
      imagesChoose: 'Chọn ảnh',
      imagesEmpty: 'Chưa chọn ảnh nào',
      imagesSelected: '{count} ảnh đã chọn',
      imagesRemove: 'Xóa',
      sectionBasicTitle: 'Thông tin cơ bản',
      sectionBasicDesc: 'Loại tin, nhu cầu và tiêu đề hiển thị trên trang chi tiết.',
      sectionPricingTitle: 'Giá & diện tích',
      sectionPricingDesc: 'Giá niêm yết và thông số diện tích, kích thước mặt bằng.',
      sectionLocationTitle: 'Khu vực tư vấn',
      sectionLocationDesc: 'Chọn khu vực hành chính và lưu địa chỉ nội bộ, không hiển thị tọa độ công khai.',
      sectionSpecsTitle: 'Thông số phòng',
      sectionSpecsDesc: 'Chọn loại phòng cần hiển thị và điều chỉnh số lượng bằng nút cộng/trừ.',
      sectionLegalTitle: 'Pháp lý & nội thất',
      sectionLegalDesc: 'Tình trạng pháp lý và mức độ trang bị nội thất.',
      sectionAmenitiesTitle: 'Tiện ích',
      sectionAmenitiesDesc: 'Chọn các tiện ích có tại bất động sản — tick để bật, bỏ tick để tắt.',
      sectionContentTitle: 'Mô tả & hình ảnh',
      sectionContentDesc: 'Nội dung chi tiết và ảnh minh họa giúp tin đăng thuyết phục hơn.',
      sectionManagementTitle: 'Quản lý tin',
      sectionManagementDesc: 'Trạng thái hiển thị và quy trình duyệt tin đăng.',
      stepNavLabel: 'Các bước tạo tin',
      stepNavBasic: 'Cơ bản',
      stepNavPricing: 'Giá & địa điểm',
      stepNavDetails: 'Chi tiết',
      stepNavPublish: 'Đăng tin',
      stepProgress: 'Bước {current}/{total}',
      stepContinue: 'Tiếp tục',
      stepErrorCategory: 'Vui lòng chọn loại bất động sản.',
      stepErrorTitle: 'Vui lòng nhập tiêu đề tin đăng.',
      stepErrorPrice: 'Vui lòng nhập giá bán hợp lệ.',
      stepErrorLocation: 'Vui lòng chọn tỉnh/thành phố và phường/xã.',
      titlePlaceholder: 'Ví dụ: Nhà phố 3 tầng mặt tiền 5m, nội thất đầy đủ',
      descriptionPlaceholder: 'Mô tả vị trí, diện tích, tiện ích và điểm nổi bật của bất động sản...',
    },
    options: {
      transactionType: [
        { value: 'sale', label: 'Bán' },
      ],
      status: [
        { value: 'active', label: 'Đang hiển thị' },
        { value: 'inactive', label: 'Tạm ẩn' },
        { value: 'sold', label: 'Đã bán' },
      ],
      publicationStatus: [
        { value: 'draft', label: 'Bản nháp' },
        { value: 'pending', label: 'Chờ duyệt' },
        { value: 'published', label: 'Đã đăng' },
        { value: 'rejected', label: 'Bị từ chối' },
        { value: 'archived', label: 'Lưu trữ' },
      ],
      furnishedStatus: [
        { value: 'unfurnished', label: 'Không nội thất' },
        { value: 'semi_furnished', label: 'Nội thất cơ bản' },
        { value: 'furnished', label: 'Đầy đủ nội thất' },
      ],
      features: [
        { fieldName: 'has_parking', label: 'Chỗ đậu xe', resourceKey: 'parking' },
        { fieldName: 'has_balcony', label: 'Ban công', resourceKey: 'balcony' },
        { fieldName: 'has_elevator', label: 'Thang máy', resourceKey: 'elevator' },
        { fieldName: 'has_garden', label: 'Sân vườn', resourceKey: 'garden' },
        { fieldName: 'has_swimming_pool', label: 'Hồ bơi', resourceKey: 'swimming_pool' },
        { fieldName: 'has_security', label: 'An ninh', resourceKey: 'security' },
      ],
      roomSpecs: [
        { fieldName: 'bedrooms', label: 'Phòng ngủ' },
        { fieldName: 'master_bedrooms', label: 'Phòng master' },
        { fieldName: 'bathrooms', label: 'Phòng tắm' },
        { fieldName: 'toilets', label: 'Toilet' },
        { fieldName: 'kitchens', label: 'Phòng bếp' },
        { fieldName: 'living_rooms', label: 'Phòng khách' },
        { fieldName: 'gym_rooms', label: 'Phòng thể dục' },
        { fieldName: 'worship_rooms', label: 'Phòng thờ' },
        { fieldName: 'floors', label: 'Số tầng' },
      ],
      sort: [
        { value: 'latest', label: 'Mới nhất' },
        { value: 'lowest_price', label: 'Giá thấp nhất' },
        { value: 'highest_price', label: 'Giá cao nhất' },
        { value: 'most_viewed', label: 'Xem nhiều nhất' },
      ],
      priceMin: [
        { value: '1000000000', label: 'Từ 1 tỷ' },
        { value: '3000000000', label: 'Từ 3 tỷ' },
        { value: '7000000000', label: 'Từ 7 tỷ' },
      ],
      priceMax: [
        { value: '3000000000', label: 'Dưới 3 tỷ' },
        { value: '7000000000', label: 'Dưới 7 tỷ' },
        { value: '15000000000', label: 'Dưới 15 tỷ' },
      ],
      areaMin: [
        { value: '50', label: 'Từ 50 m²' },
        { value: '100', label: 'Từ 100 m²' },
        { value: '200', label: 'Từ 200 m²' },
      ],
      areaMax: [
        { value: '100', label: 'Dưới 100 m²' },
        { value: '200', label: 'Dưới 200 m²' },
        { value: '500', label: 'Dưới 500 m²' },
      ],
      frontageMin: [
        { value: '3', label: 'Từ 3 m' },
        { value: '5', label: 'Từ 5 m' },
        { value: '8', label: 'Từ 8 m' },
        { value: '12', label: 'Từ 12 m' },
      ],
      plotLengthMin: [
        { value: '10', label: 'Từ 10 m' },
        { value: '15', label: 'Từ 15 m' },
        { value: '20', label: 'Từ 20 m' },
        { value: '30', label: 'Từ 30 m' },
      ],
    },
    infoModal: {
      eyebrow: 'Thông tin nhanh',
      price: 'Giá',
      pricePerSqm: 'Giá/m²',
      transaction: 'Nhu cầu',
      category: 'Loại BĐS',
      publicationStatus: 'Trạng thái duyệt',
      address: 'Địa chỉ',
      region: 'Khu vực',
      area: 'Diện tích',
      bedroomBathroom: 'Phòng ngủ / WC',
      bedroomCount: '{count} Phòng ngủ',
      bathroomCount: '{count} WC',
      kitchenCount: '{count} Phòng bếp',
      views: 'Lượt xem',
      legal: 'Pháp lý',
      noDescription: 'Tin đăng chưa có mô tả.',
      images: 'Hình ảnh',
      noImages: 'Chưa có hình ảnh',
      coverBadge: 'Ảnh bìa',
      openImage: 'Xem ảnh {index}',
    },
  },
  contact: {
    formTitle: 'Nhận tư vấn miễn phí',
    formDescription: 'Để lại thông tin, nhân viên sẽ gọi lại và giải thích rõ ràng cho bạn.',
    fullName: 'Họ tên',
    email: 'Email',
    phone: 'Số điện thoại',
    message: 'Nội dung',
    submit: 'Gửi yêu cầu tư vấn',
    callNow: 'Gọi ngay: 0977545638',
    defaultMessage: 'Tôi muốn được tư vấn thêm về bất động sản này.',
  },
  favorites: {
    breadcrumb: 'Yêu thích',
    eyebrow: 'Danh sách cá nhân',
    title: 'Bất động sản yêu thích',
    description: 'Những tin bạn đã lưu để xem lại hoặc liên hệ tư vấn sau.',
    savedCountSuffix: 'tin đã lưu',
    browseMore: 'Tìm thêm BĐS',
    emptyTitle: 'Bạn chưa lưu bất động sản nào',
    emptyMessage: 'Khi thấy tin phù hợp, hãy bấm lưu để quay lại xem sau.',
    findProperties: 'Tìm bất động sản',
    saveLabel: 'Lưu yêu thích',
    removeLabel: 'Bỏ yêu thích',
    noteLabel: 'Ghi chú cá nhân',
    notePlaceholder: 'Ví dụ: thích vì gần trường, cần hỏi pháp lý...',
    noteSave: 'Lưu ghi chú',
    noteSaving: 'Đang lưu...',
    noteSaved: 'Đã lưu ghi chú.',
    noteError: 'Không thể lưu ghi chú.',
    removeFavorite: 'Bỏ yêu thích',
    removingFavorite: 'Đang bỏ...',
  },
  share: {
    button: 'Chia sẻ',
    dialogTitle: 'Chia sẻ tin này',
    facebook: 'Facebook',
    messenger: 'Messenger',
    zalo: 'Zalo',
    copyLink: 'Sao chép liên kết',
    email: 'Email',
    copied: 'Đã sao chép liên kết.',
    zaloCopied: 'Đã sao chép link — dán vào Zalo để chia sẻ.',
    failed: 'Không thể chia sẻ liên kết.',
    defaultTitle: 'Xem bất động sản này',
  },
  badges: {
    new: 'Mới',
    hot: 'Hot',
  },
  search: {
    propertySuggestions: 'Tin đăng',
    locationSuggestions: 'Khu vực',
  },
  searchBar: {
    locationLabel: 'Khu vực',
    locationPlaceholder: 'Tìm theo tên tin, đường...',
    provinceLabel: 'Vị trí',
    provinceShort: 'Vị trí',
    provinceAll: 'Toàn quốc',
    wardAll: 'Tất cả phường/xã',
    provinceSearchPlaceholder: 'Tìm tỉnh / thành phố...',
    categoryShort: 'Loại nhà đất',
    moreFilters: 'Bộ lọc',
    popoverTitle: 'Bộ lọc tìm kiếm',
    priceLabel: 'Mức giá',
    priceAny: 'Bất kỳ giá',
    transactionAny: 'Mua hoặc thuê',
    bedroomAny: 'Bất kỳ',
    filtersButton: 'Lọc',
    mobilePanelTitle: 'Tìm kiếm nâng cao',
    mobileSummaryHint: 'Chạm để thêm bộ lọc',
    pricePresets: [
      { value: '', label: 'Bất kỳ giá' },
      { value: 'under-3b', label: 'Dưới 3 tỷ' },
      { value: '3b-7b', label: '3 - 7 tỷ' },
      { value: 'over-7b', label: 'Trên 7 tỷ' },
      { value: 'from-1b', label: 'Từ 1 tỷ' },
    ],
  },
  profile: {
    breadcrumb: 'Hồ sơ',
    eyebrow: 'Tài khoản',
    title: 'Thông tin cá nhân',
    description: 'Cập nhật thông tin liên hệ và nhu cầu tìm kiếm để được tư vấn phù hợp hơn.',
    descriptionSeller: 'Cập nhật thông tin liên hệ để khách hàng và hệ thống liên lạc thuận tiện hơn.',
    sectionBasic: 'Thông tin liên hệ',
    sectionPreferences: 'Nhu cầu tìm kiếm',
    emailHint: 'Email dùng để đăng nhập và không thể thay đổi.',
    budgetHint: 'Nhập số tiền bằng VNĐ, ví dụ: 3000000000 cho 3 tỷ.',
    address: 'Địa chỉ',
    addressPlaceholder: 'Ví dụ: Quận 1, TP.HCM',
    preferredProvince: 'Khu vực quan tâm',
    preferredProvincePlaceholder: 'Ví dụ: TP.HCM',
    budgetMin: 'Ngân sách tối thiểu',
    budgetMax: 'Ngân sách tối đa',
    saved: 'Đã cập nhật hồ sơ.',
    saveError: 'Không thể cập nhật hồ sơ.',
    saveButton: 'Lưu hồ sơ',
    avatarSection: 'Ảnh đại diện',
    avatarHint: 'Chọn ảnh JPG hoặc PNG, tối đa 2MB.',
    avatarChoose: 'Chọn avatar',
    avatarSave: 'Cập nhật avatar',
    avatarUploading: 'Đang cập nhật...',
    avatarSelected: 'Đã chọn: {name}',
    avatarTypeError: 'Avatar chỉ được dùng file JPG, JPEG hoặc PNG.',
    avatarSaved: 'Đã cập nhật avatar.',
    avatarSaveError: 'Không thể cập nhật avatar.',
  },
  admin: {
    brand: 'RealEstate Admin',
    sidebar: {
      tagline: 'Bảng điều khiển quản trị',
      menuLabel: 'Menu',
      superAdminRole: 'Superadmin',
      adminRole: 'Admin',
      viewWebsiteHint: 'Quay về trang công khai',
      openMenu: 'Mở menu',
      closeMenu: 'Đóng menu',
    },
    dashboardEyebrow: 'Quản trị',
    dashboardTitle: 'Tổng quan',
    addProperty: 'Thêm bất động sản',
    deleteConfirm: 'Bạn có chắc muốn xóa tin "{title}"?',
    deleteDialogTitle: 'Xóa tin đăng',
    deleteDialogHint: 'Tin sẽ bị xóa vĩnh viễn khỏi hệ thống và không thể khôi phục.',
    titleColumn: 'Tiêu đề',
    propertiesEyebrow: 'Quản trị thông tin',
    propertiesTitle: 'Quản lý bài đăng',
    addNew: 'Thêm mới',
    propertiesNav: 'Quản lý bài đăng',
    contactsNav: 'Quản lý liên hệ',
    usersNav: 'Quản lý quản trị viên',
    managedUsersNav: 'Quản lý người dùng',
    contactsEyebrow: 'Khách hàng',
    contactsTitle: 'Quản lý liên hệ',
    customerColumn: 'Khách hàng',
    propertyColumn: 'Bất động sản',
    messageColumn: 'Nội dung',
    statusColumn: 'Trạng thái',
    needColumn: 'Nhu cầu',
    priceColumn: 'Giá',
    locationColumn: 'Vị trí',
    viewsColumn: 'Lượt xem',
    publicationColumn: 'Xuất bản',
    actionsColumn: 'Thao tác',
    contactsEmptyTitle: 'Chưa có liên hệ',
    contactsEmptyMessage: 'Khi khách gửi form tư vấn, thông tin sẽ xuất hiện tại đây.',
    contacts: {
      searchPlaceholder: 'Tìm theo tên, email, SĐT hoặc nội dung...',
      filterAll: 'Tất cả',
      filterNew: 'Mới',
      filterRead: 'Đã đọc',
      filterReplied: 'Đã phản hồi',
      resultsCount: '{count} liên hệ',
      noResultsTitle: 'Không tìm thấy liên hệ',
      noResultsMessage: 'Thử đổi từ khóa hoặc chọn bộ lọc khác.',
      noProperty: 'Liên hệ không gắn với tin đăng cụ thể',
    },
    viewPropertyInfo: 'Thông tin BĐS',
    propertiesEmptyTitle: 'Chưa có tin đăng',
    propertiesEmptyMessageCreate: 'Hãy thêm bất động sản đầu tiên để hiển thị trên website.',
    propertiesEmptyMessageView: 'Hiện chưa có tin đăng để quản lý.',
    addListing: 'Thêm tin',
    properties: {
      searchPlaceholder: 'Tìm theo tiêu đề hoặc vị trí...',
      filterAll: 'Tất cả',
      filterPending: 'Chờ duyệt',
      filterPublished: 'Đã đăng',
      filterDraft: 'Bản nháp',
      filterListingStatus: 'Trạng thái tin',
      filterTransaction: 'Nhu cầu',
      resultsCount: '{count} tin đăng',
      noResultsTitle: 'Không tìm thấy tin phù hợp',
      noResultsMessage: 'Thử đổi từ khóa hoặc chọn bộ lọc khác.',
    },
    stats: {
      total: 'Tổng tin',
      active: 'Đang hiển thị',
      contacts: 'Liên hệ',
      newContacts: 'Liên hệ mới',
      drafts: 'Bản nháp',
      pending: 'Chờ duyệt',
    },
    dashboard: {
      welcome: 'Xin chào, {name}!',
      subtitle:
        'Tổng quan nhanh về tin đăng và liên hệ khách hàng. Mọi thứ bạn cần quản lý hôm nay đều ở đây.',
      overviewTitle: 'Thống kê tổng quan',
      overviewSubtitle: 'Số liệu cập nhật theo thời gian thực từ hệ thống.',
      quickActionsTitle: 'Thao tác nhanh',
      quickActionsSubtitle: 'Đi tới các trang quản lý thường dùng nhất.',
      statTotalDesc: 'Tất cả tin đăng trong hệ thống',
      statActiveDesc: 'Tin đang public trên website',
      statContactsDesc: 'Tổng yêu cầu tư vấn đã nhận',
      statNewContactsDesc: 'Liên hệ chưa được xử lý',
      statDraftsDesc: 'Tin chưa hoàn thiện hoặc chưa gửi',
      statPendingDesc: 'Tin chờ superadmin duyệt',
      alertPending: '{count} tin đang chờ duyệt',
      alertPendingHint: 'Hãy kiểm tra và duyệt để tin được hiển thị công khai.',
      alertPendingAction: 'Xem tin chờ duyệt',
      alertContacts: '{count} liên hệ mới',
      alertContactsHint: 'Khách hàng đang chờ bạn phản hồi tư vấn.',
      alertContactsAction: 'Xử lý liên hệ',
      actionContactsTitle: 'Quản lý liên hệ',
      actionContactsDesc: 'Xem và cập nhật trạng thái yêu cầu tư vấn',
      actionPendingDesc: 'Kiểm tra và duyệt các tin đang chờ xuất bản',
      tipLabel: 'Mẹo nhỏ',
      tipText:
        'Ưu tiên xử lý liên hệ mới và tin chờ duyệt trước để khách hàng nhận phản hồi nhanh hơn.',
    },
    contactStatus: {
      new: 'Mới',
      read: 'Đã đọc',
      replied: 'Đã phản hồi',
    },
    users: {
      eyebrow: 'Superadmin',
      title: 'Quản lý quản trị viên',
      createTitle: 'Tạo quản trị viên mới',
      createHint:
        'Đăng ký công khai chỉ tạo tài khoản user. Quản trị viên chỉ được tạo bởi superadmin.',
      fullName: 'Họ tên',
      email: 'Email',
      phone: 'Số điện thoại',
      tempPassword: 'Mật khẩu tạm',
      createButton: 'Tạo tài khoản quản trị viên',
      resultsCount: '{count} tài khoản quản trị viên',
      searchPlaceholder: 'Tìm theo tên, email hoặc SĐT...',
      listTitle: 'Danh sách quản trị viên',
      noResultsTitle: 'Không tìm thấy quản trị viên',
      roleLabel: 'Quản trị viên',
      resetPasswordHint: 'Mật khẩu mới tối thiểu 8 ký tự. Quản trị viên sẽ cần đăng nhập lại.',
      adminColumn: 'Quản trị viên',
      contactColumn: 'Liên hệ',
      resetPasswordColumn: 'Cấp lại password',
      newPasswordPlaceholder: 'Mật khẩu mới',
      resetButton: 'Cấp lại',
      resetting: 'Đang cấp...',
      emptyTitle: 'Chưa có quản trị viên',
      emptyMessage: 'Superadmin có thể tạo tài khoản quản trị viên đầu tiên tại form phía trên.',
      createSuccess: 'Đã tạo tài khoản quản trị viên mới.',
      resetSuccess: 'Đã cấp lại mật khẩu quản trị viên. Tài khoản đó cần đăng nhập lại.',
      passwordMinLength: 'Mật khẩu mới phải có ít nhất 8 ký tự.',
    },
    managedUsers: {
      eyebrow: 'Superadmin',
      title: 'Quản lý người dùng',
      listTitle: 'Danh sách người dùng',
      resultsCount: '{count} người dùng',
      searchPlaceholder: 'Tìm theo tên, email, SĐT, CCCD...',
      roleLabel: 'Người dùng',
      preferredProvince: 'Khu vực quan tâm',
      budgetRange: 'Ngân sách',
      privateSectionTitle: 'Thông tin nội bộ',
      privateSectionHint:
        'Superadmin nhập sau khi liên hệ khách có nhu cầu mua BĐS. Người dùng không thấy các mục này trên hồ sơ.',
      residentialAddress: 'Địa chỉ cư trú',
      hometown: 'Quê quán',
      residence: 'Nơi ở',
      age: 'Tuổi',
      cccd: 'CCCD',
      editTitle: 'Cập nhật thông tin nội bộ',
      editHint: 'Nhập thông tin thu thập khi tư vấn khách hàng.',
      saveButton: 'Lưu thông tin',
      updateSuccess: 'Đã cập nhật thông tin người dùng.',
      emptySelectionTitle: 'Chọn người dùng',
      emptySelectionMessage: 'Chọn một người dùng trong danh sách để cập nhật thông tin nội bộ.',
      emptyTitle: 'Chưa có người dùng',
      emptyMessage: 'Khi khách đăng ký tài khoản, danh sách sẽ hiển thị tại đây.',
      noResultsTitle: 'Không tìm thấy người dùng',
    },
  },
  messages: {
    searchingProperties: 'Đang tìm bất động sản...',
    loadingAccount: 'Đang tải thông tin tài khoản...',
    loadingData: 'Đang tải dữ liệu...',
    loadingProperty: 'Đang tải tin đăng...',
    propertyLoadError: 'Không thể tải danh sách bất động sản. Vui lòng thử lại.',
    propertySaveError: 'Không thể lưu tin đăng. Vui lòng kiểm tra lại.',
    propertyPriceRequired: 'Giá bán phải lớn hơn 0.',
    propertyDescriptionRequired: 'Vui lòng nhập mô tả bất động sản.',
    propertyImagesRequired: 'Vui lòng chọn ít nhất một ảnh.',
    propertyPricePerSqmRequired: 'Giá/m² phải lớn hơn 0.',
    propertyAreaRequired: 'Diện tích phải lớn hơn 0 m².',
    propertyLocationRequired:
      'Vui lòng chọn đúng Tỉnh/Thành phố, Quận/Huyện và Phường/Xã từ danh sách.',
    propertyAddressRequired: 'Vui lòng nhập địa chỉ cụ thể của bất động sản.',
    propertyImageTypeError: 'Ảnh bất động sản chỉ được dùng file JPG, JPEG hoặc PNG.',
    registerError: 'Không thể đăng ký. Vui lòng kiểm tra lại.',
    loginError: 'Email hoặc mật khẩu chưa đúng.',
    contactError: 'Không thể gửi liên hệ. Vui lòng thử lại.',
    contactSuccess: 'Đã gửi thông tin. Chúng tôi sẽ gọi lại cho bạn trong 24h.',
    favoriteError: 'Không thể lưu yêu thích. Vui lòng thử lại.',
    favoriteLoginRequired: 'Vui lòng đăng nhập để lưu bất động sản yêu thích.',
    favoriteSaved: 'Đã lưu vào danh sách yêu thích.',
    adminUsersLoadError: 'Không thể tải danh sách quản trị viên.',
    adminUserCreateError: 'Không thể tạo tài khoản quản trị viên.',
    adminPasswordResetError: 'Không thể cấp lại mật khẩu quản trị viên.',
    managedUsersLoadError: 'Không thể tải danh sách người dùng.',
    managedUserUpdateError: 'Không thể cập nhật thông tin người dùng.',
  },
  breadcrumbs: {
    home: 'Trang chủ',
  },
};
